import service from '@/services/contabilidad/iva'

const getDefaultState = () => ({
  values: {
    creditoImportaciones: 0,
    saldoAnterior: 0,
    retenciones: 0,

    totalImpuestoVentas: 0,
    totalCredito: 0,
    totalImpuesto: 0, // iva por pagar, si es negativo es poque tiene un saldo para el siguiente periodo.
    saldo: 0 // saldo del periodo.
  }
})

export const state = () => getDefaultState()

export const mutations = {
  // RESET_STATE: state => Object.assign(state, getDefaultState()),
  // SET: (state, obj) => {
  //   state.list = obj
  // }
  SET_VALUES: (state, obj) => {
    state.values.totalImpuestoVentas = obj.totalImpuestoVentas
    state.values.totalCredito = obj.totalCredito
    state.values.totalImpuesto = obj.totalImpuesto
    state.values.saldo = obj.saldo
  },
  SET_SALDO: (state, val) => {
    state.values.saldoAnterior = val ? val.toFixed(2) : 0
  }
}

export const actions = {
  // resetList: ({ state }) => {
  //   state.list = []
  //   state.listTypes = []
  // },

  findOne: async ({ commit, state, dispatch, rootGetters }, { start, end }) => {
    // si es el último periodo carga el ultimo registro
    const period = {
      start: null,
      end: null
    }

    // Busca el saldo del periodo anterior al seleccionado
    period.start = new Date(start.getFullYear(), start.getMonth() - 1, 1)
    period.end = new Date(start.getFullYear(), start.getMonth(), 0, 23, 59, 59)


    return service.findOne(rootGetters['facturacion/emisorStore/get_Id'], period.start, period.end).then(response => {
      // ultimo registro de saldo
      commit('SET_SALDO', response?.saldo || 0)
    })
  },

  create: async ({ commit, state, dispatch, rootGetters }, { start, end }) => {
    return service.create({
      _idEmisor: rootGetters['facturacion/emisorStore/get_Id'],
      start,
      end,
      totalImpuestoVentas: state.values.totalImpuestoVentas,
      totalCredito: state.values.totalCredito,
      totalImpuesto: state.values.totalImpuesto,
      saldo: state.values.saldo
    })
  }
}
